/* eslint-disable no-console */
import React, { useRef, useState, useMemo } from 'react';
import styled, { withTheme } from 'styled-components';
import { Icon } from 'components/atoms';
import { useOnClickOutside } from 'hooks';
import { useDebouncedCallback } from 'use-debounce';
import PropTypes from 'prop-types';
import { themeType } from 'types';

const SearchBar = ({ handleSearch, disabled, theme }) => {
  const inputEl = useRef(null);
  const [isFocus, setFocus] = useState(false);

  const setFocused = isFocus => {
    setFocus(isFocus);
    if (isFocus === true) inputEl.current.focus();
  };

  useOnClickOutside(inputEl, () => setFocused(false));

  // debounce value
  const debouncedCallback = useDebouncedCallback(
    value => {
      handleSearch(value);
    },
    100
  );

  const disabledStyles = useMemo(() => {
    if (!disabled) {
      return {
        iconColor: theme.colors.base,
      };
    }
    return {
      iconColor: theme.colors.greyLight,
    };
  }, [disabled, theme.colors.base, theme.colors.greyLight]);

  return (
    <Wrapper
      onClick={() => setFocused(true)}
      isFocus={isFocus}
      disabled={disabled}
    >
      <Icon icon="search" color={disabledStyles.iconColor} />
      <Input
        placeholder="Search sections..."
        ref={inputEl}
        onChange={e => debouncedCallback(e.target.value)}
        disabled={disabled}
      />
    </Wrapper>
  );
};

SearchBar.propTypes = {
  handleSearch: PropTypes.func,
  disabled: PropTypes.bool,
  theme: themeType.isRequired,
};

SearchBar.defaultProps = {
  handleSearch: value => console.log(value),
  disabled: false,
};

const Wrapper = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.bgLighterS};
  padding: ${props => `${props.theme.spacing.xs2} ${props.theme.spacing.s}`};
  border-radius: ${props => props.theme.values.borderRadius};
  max-width: ${props => props.theme.components.form.maxWidth};
  margin-bottom: ${props => props.theme.spacing.xs};
  border: ${props => (props.isFocus && !props.disabled
    ? `1px solid ${props.theme.colors.primary}`
    : `1px solid ${props.theme.colors.bgLighterS}`)};
  cursor: text;
`;

const Input = styled.input`
  background-color: ${props => props.theme.colors.bgLighterS};
  border: 0;
  width: 100%;
  margin-left: ${props => props.theme.spacing.s};
  &::placeholder {
    color: ${props => props.theme.colors.baseLighter};
  }
  &:focus {
    outline: 0;
  }
  &:disabled {
    opacity: 0;
  }
`;

export default withTheme(SearchBar);
